const key_prefix = '@meapoia.com';

export const LOCAL_STORAGE_KEY = {
  accept_terms: `${key_prefix}:accept_terms`,
};
